import {
  CardStyled,
  FieldContainer,
  FieldText,
  HeaderFieldContainer,
  HeaderFieldText,
  CardDescriptionContainer,
  ImageContainer,
  ImageStyled,
  SubHeaderContainer,
} from './CardEvent.style';
import React from 'react';
import { useRouter } from 'next/router';
import { DEFAULT_IMAGE } from '../../../models/domain/const';
import {
  LocationOnOutlinedIcon,
  ScheduleIcon,
  StorefrontIcon,
} from '../../../assets';
import { EventCardType } from '../../../models/enum';
import { CardEventData } from '../card-event-mobile/CardEventMobile';

interface CardProps {
  data: CardEventData;
  cardType?: EventCardType;
}

const CardEvent: React.FC<CardProps> = ({
  data,
  cardType = EventCardType.BIG,
}) => {
  const router = useRouter();
  const { image, fair, startDate, endDate, stand, url, location } = data || {};

  const cardIsBig = cardType === EventCardType.BIG;

  return (
    <CardStyled onClick={() => router.push(url)} $cardIsBig={cardIsBig}>
      <ImageContainer
        $cardIsBig={cardIsBig}
        $hasImage={!!image?.attributes?.url}
      >
        <ImageStyled
          src={image?.attributes?.url || DEFAULT_IMAGE}
          $hasImage={!!image?.attributes?.url}
          alt={image?.attributes?.alternativeText || ''}
        />
      </ImageContainer>
      <CardDescriptionContainer $cardIsBig={cardIsBig}>
        <HeaderFieldContainer $cardIsBig={cardIsBig}>
          <HeaderFieldText $cardIsBig={cardIsBig}>{fair ?? ''}</HeaderFieldText>
        </HeaderFieldContainer>
        <SubHeaderContainer $cardIsBig={cardIsBig}>
          <FieldContainer $cardIsBig={cardIsBig}>
            <LocationOnOutlinedIcon />
            <FieldText $cardIsBig={cardIsBig}>{location ?? '-'}</FieldText>
          </FieldContainer>
          <FieldContainer $cardIsBig={cardIsBig}>
            <ScheduleIcon />
            <FieldText $cardIsBig={cardIsBig}>
              {startDate ?? 'N/A'} - {endDate ?? 'N/A'}
            </FieldText>
          </FieldContainer>
          {cardType === EventCardType.BIG && (
            <FieldContainer $cardIsBig={true}>
              <StorefrontIcon />
              <FieldText $cardIsBig={true}>{stand ?? '-'}</FieldText>
            </FieldContainer>
          )}
        </SubHeaderContainer>
      </CardDescriptionContainer>
    </CardStyled>
  );
};

export default CardEvent;
